import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { mapActions } from "vuex";
import { LibraryPageApi } from "../../assets/js/ApiInterface";
import Image from "../../views/dashboard/library/Image";
import { DynamicModel } from "../../views/dashboard/models/DynamicModel";
import Pagination from "../../views/dashboard/models/Pagination";
export default {
  name: "MultimediaDialog",
  components: {
    Library: () => import("./Library")
  },
  props: {
    value: {},
    data: {
      type: Object
    }
  },
  data() {
    return {
      imageUrl: null,
      uploading: false,
      upload_event: e => console.log('upload_event')
    };
  },
  computed: {
    modalModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      }
    },
    dataModel: {
      get() {
        return this.imageUrl;
      },
      set(v) {
        this.imageUrl = v;
        this.$emit('image', v);
      }
    }
  },
  methods: {
    ...mapActions(['SendRequest']),
    openUploadPanel() {
      let upload_input = document.getElementById('multi-media-dialog-input');
      if (upload_input) upload_input.click();
    },
    async uploadMedia(e) {
      let files = e.target.files;
      if (files instanceof FileList) {
        for (let i = 0; i < files.length; i++) {
          let data = [{
            name: 'file',
            value: files.item(i)
          }, {
            name: 'folder',
            value: this.data.imageFolder
          }];
          (await this.SendRequest(LibraryPageApi.saveSingleImage(data, 'form-data'))).OnStart(() => this.uploading = true).OnValidationErrors(() => this.uploading = false).OnSuccess(dynamicPaginatedImages => {
            this.$refs.library.dispatchUploadEvent(dynamicPaginatedImages, 'image');
            let images = dynamicPaginatedImages.getCreatedModels();
            if (Array.isArray(images)) images.forEach(image => this.dataModel = image);
          }, new DynamicModel(Pagination, Image)).OnFailure(() => this.uploading = false).OnFinished(() => this.uploading = false);
        }
      } else console.log('data not type of FileList');
    }
  }
};